"use client";

import { useLinkStatus } from "next/link";

import cn from "classnames";

import { Loader } from "@/components/loader/loader.component";

export function ProductCardLinkPendingIndicator() {
  const { pending } = useLinkStatus();

  return (
    <span
      aria-hidden
      className={cn(
        "absolute inset-0 flex items-center justify-center rounded-2xl bg-white/40 opacity-0 transition-opacity delay-100 duration-200",
        { "opacity-100": pending },
      )}>
      <Loader loading={pending} size="md" variant="secondary" />
    </span>
  );
}
